import React from 'react'
import PropTypes from 'prop-types'
import {Table, Column, Cell} from 'components/Table'
import Checkbox from 'components/Checkbox'
import {countries} from 'countries-list/cjs'

export default class EditRegionForm extends React.Component {
  static propTypes = {
    countriesLimit: PropTypes.array,
    onRemoveContries: PropTypes.func.isRequired
  }

  static contextTypes = {
    permissions: PropTypes.object
  }

  constructor(props) {
    super(props)
    this.state = {
      selectedCountries: []
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      selectedCountries: []
    })
  }

  render() {
    const {countriesLimit} = this.props
    const {selectedCountries} = this.state
    const data = countriesLimit.map(item => {
      return {
        country: item
      }
    })

    return (
      <form
        className='settings-region-view_edit-form'
        onSubmit={this.handleSubmit}
      >
        <Table data={data} empty='All countries are displayed'>
          <Column
            header='Country limit'
            grow
            cell={data => <Cell>{countries[data.country]?.name}</Cell>}
          />
          <Column
            header='Select'
            width='100px'
            className='is-checkbox'
            cell={data => {
              return (
                <Cell className='is-checkbox'>
                  <Checkbox
                    checked={selectedCountries.includes(data.country)}
                    onChange={checked => this.onSelect(data.country, checked)}
                  />
                </Cell>
              )
            }}
          />
        </Table>
        <div className='settings-categories-view_edit-form_button'>
          <button className='is-red' type='submit'>
            Remove selected
          </button>
        </div>
      </form>
    )
  }

  onSelect = (id, checked) => {
    const {selectedCountries} = this.state

    if (checked) {
      this.setState({
        selectedCountries: !selectedCountries.includes(id)
          ? [...selectedCountries, id]
          : selectedCountries
      })
    } else if (selectedCountries.includes(id)) {
      const index = selectedCountries.findIndex(mapping => mapping === id)

      this.setState({
        selectedCountries: [
          ...selectedCountries.slice(0, index),
          ...selectedCountries.slice(index + 1)
        ]
      })
    }
  }

  handleSubmit = evt => {
    evt.preventDefault()
    const {onRemoveContries} = this.props
    const {selectedCountries} = this.state

    onRemoveContries(selectedCountries)
  }
}



// WEBPACK FOOTER //
// ./client/views/SettingsRegionView/EditRegionForm.js